import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(-7.000000, 5.000000)">
        <circle cx="50" cy="50" r="45" fill="none" stroke="currentColor" stroke-width="5" />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 20 20 L 40 50 L 60 20 M 40 50 L 40 80"
      />
    </g>
  </svg>
);

export default IconLoader;
